import Decimal from "decimal.js";
import Parameter from "../utils/parameter.js";

export default class OP1BackOff extends Parameter {
    constructor(initialValue, overrides) {
        let args = overrides || {};
        args.name = "OP1BackOff";
        args.value = initialValue;
        args.unit = Parameter.valueOrDefault(args.unit, "dB");

        args.minValue = Parameter.valueOrDefault(args.minValue, 0);
        args.maxValue = Parameter.valueOrDefault(args.maxValue, 99.99);

        args.isEnabled = Parameter.valueOrDefault(args.isEnabled, false);
        args.isWatched = Parameter.valueOrDefault(args.isWatched, false);

        args.cascadeWatched = Parameter.valueOrDefault(args.cascadeWatched, ["IP1BackOff"]);
        args.cascadeEnabled = Parameter.valueOrDefault(args.cascadeEnabled, ["IP1BackOff"]);

        super(args);
    }
}